export default "__VITE_ASSET__1ddb7e34__"